import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const TempLogin = () => {
  const [loginComplete, setLoginComplete] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const { search } = window.location;

    if (search) {
      const params = new URLSearchParams(search);
      const token = params.get("token");

      if (token) {
        localStorage.setItem("token", token);
        setLoginComplete(true);
      }
    }
  }, [dispatch]);
  return <>{loginComplete && <Navigate to="/account/overview" replace />}</>;
};

export default TempLogin;
